<template>
  <!-- Dashboard Content
	================================================== -->
  <div class="dashboard-content-container" data-simplebar>
    <div class="dashboard-content-inner">
      <!-- Dashboard Headline -->
      <div class="dashboard-headline">
        <h3>Create Task</h3>

        <!-- Breadcrumbs -->
        <nav id="breadcrumbs" class="dark">
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">Dashboard</a></li>
            <li>Create Task</li>
          </ul>
        </nav>
      </div>

      <!-- Row -->
      <div class="row">
        <!-- Dashboard Box -->
        <div class="col-xl-12">
          <div class="dashboard-box margin-top-0">
            <!-- Headline -->
            <div class="headline">
              <h3><i class="icon-material-outline-note-add"></i> Create Task </h3>
            </div>

            <div class="content with-padding padding-bottom-60">
              <!-- Form -->
              <form>
                <div>
                  <input
                    type="text"
                    class="input-text with-border"
                    name="taskName"
                    placeholder="Task name"
                    required
                    v-model="taskName"
                  />
                </div>
              </form>

              <!-- Error Message -->
              <!-- <div class="notification error closeable" v-if="errorMessage">
              <p v-text="errorMessage"></p>
            </div>

            <div class="notification success closeable" v-if="validToken">
              <p>
                Registration Successful, Kindly login here
              </p>
            </div> -->
              <!-- #Error Message -->

              <!-- Create Tasks Button -->
              <button
                class="
                button
                full-width
                ripple-effect
                margin-top-10
                my-4 col-6 d-flex justify-content-center
              "
                type="submit"
                @click="createTask()"
              >
                Save Task
                <div v-if="isLoading" class="loader ml-1"></div>
              </button>
              <!-- #Create Tasks Button -->
            </div>
            <!-- <div class="clearfix"></div> -->
          </div>
        </div>
      </div>
      <!-- Row / End -->

      <!-- Footer -->
      <!-- <app-footer></app-footer> -->
      <!-- Footer / End -->
    </div>
  </div>
  <!-- Dashboard Content / End -->
</template>

<script>
  /* eslint-disable no-console */
  import { CREATE_TASK } from '../../../../core/config/endpoints/tasks';
  import { postCall } from '../../../../core/services/http.service';

  export default {
    name: 'AdminCreateTask',
    data() {
      return {
        taskName: null,
        isLoading: false,
      };
    },
    methods: {
      closeModal() {
        this.$emit('closePanel', { response: 'test message' });
      },

      createTask() {
        this.isLoading = true;
        postCall(CREATE_TASK, {
          name: this.taskName,
        })
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            this.$toast.error(`${error.response.data.message}`);
          })
          .finally(() => {
            this.isLoading = true;
          });
      },
    },
  };
</script>
